





































































import {Component, Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import SyncApi from '@/api/SyncApi';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import {
  CommonModelUtils, SyncCubeCDMSItemData, SyncCubeCDMSItemListInfo, SyncCubeCDMSItemRetrieveResponse,
  SyncProgressDoneCheckRequest
} from '@/model/CommonModel';
import CommonButton from '@/components/button/CommonButton.vue';
import DataTable from '@/components/table/DataTable.vue';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';

@Component({
             components: {
               CommonPromptDialog,
               BooleanCheckboxInput,
               CommonButton,
               DataTable,
             },
             mixins: [
               DialogEventsMixin, DefaultComponentMixin
             ]
           })
export default class SyncSelectDialog extends Mixins(DialogEventsMixin, DefaultComponentMixin) {
  protected readonly editPrivId: string = 'EDIT.SYNC';

  private bookletVisible: boolean = false;
  private visible: boolean = false;
  private allChecked: boolean = false;
  private values: SyncCubeCDMSItemListInfo[] = [];
  private subjKey: string = '';
  private title: string = '';
  private form: any = {
    data: {
      SUBJ_KEY: '',
      SUBJ_SYNC: []
    }
  };

  get getColumnLength() {
    return this.isBookletVisible ? 8 : 7;
  }

  get isBookletVisible() {
    return this.bookletVisible;
  }

  get isVisible() {
    return this.visible;
  }

  get isLoading() {
    return this.loading;
  }

  get getTitle() {
    return this.title;
  }

  get isAllChecked() {
    if (this.values.length === 0) {
      return false;
    }

    for (const value of this.values) {
      if (!value.CHECKED) {
        return false;
      }
    }
    return true;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('syncSelectDialog', (params: SyncCubeCDMSItemData) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideSyncSelectDialog', () => this.close());
  }

  private show(params: SyncCubeCDMSItemData) {
    this.visible = true;
    this.loading = true;
    this.bookletVisible = params.bookletVisible;

    const schdKey = params.selectedSyncItemData.SCHD_KEY;
    const aeSeq = params.selectedSyncItemData.AESEQ;
    this.subjKey = params.selectedSyncItemData.SUBJ_KEY.toString();
    this.form.data.SUBJ_KEY = this.subjKey;

    SyncApi.retrieveCubeCDMSItems(this.$route.params.sponsorKey, this.$route.params.studyKey, this.subjKey,
                                  {aeSeq, schdKey})
           .then((res: SyncCubeCDMSItemRetrieveResponse) => {
             if (!res.success) {
               return Promise.reject(res.errMsg);
             }

             const syncDatas = CommonModelUtils.getOrDefault(res.data, {listInfo: []}).listInfo;
             syncDatas.forEach((item: SyncCubeCDMSItemListInfo, index: number) => {
               // 첫번째 행은 무조건 체크 되어 있는 상태여야 한다.
               item.CHECKED = index === 0;
             });

             this.values = syncDatas;
             this.title = syncDatas[0].SUBJ_ID;
             this.form.data.SUBJ_SYNC = syncDatas;
           })
           .catch((errMsg) => this.afterRequestFail(errMsg))
           .finally(() => {
             this.loading = false;
           });
  }

  public onChangeCheckBox(index: number, syncData: SyncCubeCDMSItemListInfo) {
    if (index === 0) {
      syncData.CHECKED = true;
    }
  }

  public onChangeAllCheckbox(data: boolean) {
    this.allChecked = data;
    this.settingCheckBox(data);
  }

  public reset() {
    this.settingCheckBox(false);
  }

  private settingCheckBox(checked: boolean) {
    this.values.forEach((item: SyncCubeCDMSItemListInfo, index: number) => {
      if (index === 0) {
        item.CHECKED = true;
      } else {
        item.CHECKED = checked;
      }
    });
  }

  public close() {
    this.visible = false;
  }

  public sync() {
    const {sponsorKey, studyKey} = this.$route.params;
    const checkedSyncDatas
      = CommonModelUtils.getOrDefault(this.values.filter((item: SyncCubeCDMSItemListInfo) => item.CHECKED === true), []);
    checkedSyncDatas.forEach((item: SyncCubeCDMSItemListInfo, index: number) => item.SEQ_NO = index + 1);

    const params: any = {
      SUBJ_KEY: parseInt(this.form.data.SUBJ_KEY, 10),
      SUBJ_SYNC: checkedSyncDatas
    };

    this.loading = true;
    this.checkProgressDoneSync(sponsorKey, studyKey, checkedSyncDatas[0])
        .then(() => SyncApi.syncAE(sponsorKey, studyKey, this.subjKey, params))
        .then((res: any) => {
          if (res.success) {
            this.$emit('success');
          } else {
            return Promise.reject(res.errMsg);
          }
        })
        .catch((errMsg) => this.afterRequestFail(errMsg))
        .finally(() => {
          // this.loading = false;
          // loading 해제는 afterClosed에서 처리하도록. 잠깐 닫히는 순간에 sync 버튼 연타가 가능해짐
          this.visible = false;
        });
  }

  public checkProgressDoneSync(sponsorKey: string, studyKey: string, syncData: any) {
    const request: SyncProgressDoneCheckRequest = {
      aeSeq: syncData.AESEQ,
      schdKey: syncData.SCHD_KEY,
      subjKey: syncData.SUBJ_KEY
    };

    return SyncApi.isSyncProgressDoneCheck(sponsorKey, studyKey, [request])
                  .then((res) => {
                    if (res.success) {
                      return Promise.resolve(true);
                    } else {
                      return Promise.reject(res.errMsg);
                    }
                  });
  }

  public afterClosed() {
    this.values = [];
    this.loading = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('syncSelectDialog');
    this.$modal.getEventBus().$off('hideSyncSelectDialog');
  }
}
